'use client';

import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import { Icon } from '@/components/icons/svg-icons';

import { uiService } from '@/services/ui.service';

interface ToTopButtonProps {
	className: string;
	onScrollToTop: () => void;
}

export const ToTopButton = ({ className, onScrollToTop }: ToTopButtonProps) => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const subscription = uiService.onDisplayToTopButton().subscribe((isShow) => {
			setIsVisible(isShow);
		});

		return () => {
			subscription.unsubscribe();
		};
	}, []);

	const goToTop = () => {
		onScrollToTop();
	};

	return (
		<motion.div 
			className={clsx('go-top-btn', className)}
			data-show={true}
			variants={{
				visible: { 
					opacity: 1,
					visibility: 'visible'
				},
				hidden: { 
					opacity: 0,
					visibility: 'hidden'
				}
			}}
			initial="hidden"
			animate={isVisible ? 'visible' : 'hidden'}
			onClick={goToTop}
		>
			<Icon name="go-to-top" />
		</motion.div>
	);
};